import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MatSelect } from '@angular/material';
import { TranslateService } from '@ngstack/translate';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { EducationPackageService } from 'src/app/services/http/business/educationPackage/education-package.service';
import { LevelInfoService } from 'src/app/services/http/business/levelInfo/level-info.service';
import { BIDService } from 'src/app/services/common/bid.service';
import { CIDService } from 'src/app/services/common/cid.service';
import { BranchService } from 'src/app/services/http/business/branch/branch.service';
import { CompanyService } from 'src/app/services/http/business/company/company.service';
import { IBranch } from 'src/app/interfaces/branch';
import { ICompany } from 'src/app/interfaces/company';
import { ILevelInfo } from 'src/app/interfaces/levelInfo';
import { IEducationPackage } from 'src/app/interfaces/educationPackage';
import { CourseTypeService } from 'src/app/services/http/business/course-type/course-type.service';
import { ICourseType } from 'src/app/interfaces/course-type';
import { StaticValueService } from 'src/app/services/http/business/staticValue/static-value.service';
import { HoldingService } from 'src/app/services/http/business/holding/holding.service';
import { HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-exceptional-coefficients-search',
  templateUrl: './exceptional-coefficients-search.component.html',
  styleUrls: ['./exceptional-coefficients-search.component.css']
})
export class ExceptionalCoefficientsSearchComponent implements OnInit {
  param: any;
  personInfo: any;
  errObject: any;
  isOwner: boolean;
  form: FormGroup;
  errors = new Array();
  isUpdate: boolean;
  eduPackageList: IEducationPackage;
  levelInfoList: ILevelInfo;
  companyList: ICompany[];
  branchList: IBranch[];
  coursePatternList = [];
  courseTypeList: ICourseType[];
  courseStatusList: any[];

  constructor(
    private fb: FormBuilder,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private eduPackageService: EducationPackageService,
    private levelInfoService: LevelInfoService,
    private bidService: BIDService,
    private cidService: CIDService,
    private branchService: BranchService,
    private companyService: CompanyService,
    private staticValueService: StaticValueService,
    public dialogRef: MatDialogRef<ExceptionalCoefficientsSearchComponent>,
    private courseTypeService: CourseTypeService,
    private holdingService: HoldingService
  ) { }

  ngOnInit() {
    this.checkOwner();
    this.createForm();
    this.getEduPackage();
    this.getCourseStatus(true);

  }
  createForm() {
    this.form = this.fb.group({
      CompanyEncryptId: [null],
      BranchEncryptId: [null],
      PackageId: [null],
      LevelInfoId: [null],
      CoursePatternId: [null],
      TimeEnd: [null],
      TimeStart: [null],
      CourseTypeId: [null],
      CoefficientStart: [null],
      CoefficientEnd: [null]
    });
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner)
        this.getCompanyList();
    });
  }

  getEduPackage() {
    this.eduPackageService.getList().subscribe(
      res => {
        this.eduPackageList = res.DataList;
      },
      err => {
        console.log(err);
      }
    );
  }
  getLevelInfo(e: MatSelect) {
    this.levelInfoService.getList(e.value).subscribe(
      res => {
        this.levelInfoList = res.DataList;
      },
      err => {
        console.log(err);
      }
    );
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  getBranchList(company) {
    var headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        company
      );
    this.branchService.listByCompanyHeader(0, 0, headers).subscribe(res => {
      this.branchList = res.DataList;
    });

    if (this.isOwner) {
      this.cidService.setCID(company);
      this.getCourseType();
    }
  }

  getCourseType() {
    this.courseTypeService.list(0, 0).subscribe(res => {
      this.courseTypeList = res.DataList;
    });
  }

  setValueCourseTypeToChildren(e: MatSelect) {

    this.coursePatternList = e.value.CoursePatternList;
    this.form.controls['CourseTypeId'].setValue(e.value.Id);
  }


  getCourseStatus(time: boolean) {
    this.staticValueService.courseStatus(time).subscribe(
      res => {

        this.courseStatusList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  setCid(e: MatSelect) {
    this.cidService.setCID(e.value);
    this.getBranchList(e.value);
  }

  setBid(e: MatSelect) {
    if (this.isOwner)
      this.bidService.setBID(e.value);
  }

  submit(data: any) {

    this.dialogRef.close(data);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
